import cs from 'smarttech-cs-v2-sdk-release'
import ContentServiceClient from '../services/content-service-client'
import Environment from '../plugins/environment'
import { CS } from '../enums/clients'

const requestTimeout = 60000 // 60 seconds

export default {
  getCSClient({accessToken, region}) {
    let apiClient = new cs.ApiClient() // new window.SMARTContentV2.ApiClient()
    const contentServicesUrl = Environment.serviceUrlFor(CS, region)

    if (accessToken !== null) {
      apiClient.setAccessToken(accessToken)
    }
    if (contentServicesUrl) {
      apiClient.setContentUrl(contentServicesUrl)
    } else {
      throw new Error('Unable to initialize content services SDK')
    }

    if (requestTimeout) {
      apiClient.setRequestTimeout(requestTimeout)
    }

    return new ContentServiceClient(apiClient, cs)
  }
}
